import { useCurrentGroupContext } from "hooks/useCurrentGroupContext";
import { useRoleBasedView } from "hooks/useRoleBasedView";
import { ReactNode } from "react";
import { Section } from "types/Models/Filing";
import { Task } from "types/Models/task";
import { FilingSectionReview } from "../FilingReview/FilingSectionReview";

export const ReviewForm = ({
  sections,
  children,
  task,
}: {
  sections: Section[];
  children?: ReactNode;
  task: Task;
}) => {
  const { isCustomer } = useRoleBasedView();
  const { uuid: groupId } = useCurrentGroupContext();

  return (
    <div className="t-w-full">
      <div className="t-w-full t-space-y-4 t-mb-4">
        {sections
          ?.filter(
            (section: Section) =>
              !(section.is_hidden_for_customer && isCustomer)
          )
          ?.map((section: Section, index: React.Key | null | undefined) => {
            return (
              <FilingSectionReview
                key={index}
                updatedTask={task}
                formId={task.form_data.uuid}
                section={section}
                updateSectionKeyIdPair={() => {}}
                updateRemovedSectionIds={() => {}}
                groupId={groupId}
                isArchived={false}
                entityId={task.entity.uuid}
                formData={task.form_data}
                season={task.season}
                deadline={task.deadline}
                entityName={task?.entity?.name}
              />
            );
          })}
      </div>
      {children}
    </div>
  );
};
